import React from "react";
import {useHeader} from "../../_metronic/layout";
import {useSubheader} from "../../_metronic/layout";
import {useIntl} from "react-intl";
import Law from "../modules/Law/LawPage";
import {shallowEqual, useSelector} from "react-redux";
import type {RootStateAgents} from "../modules/Law/types";

export function LawPage() {
  const {totalPaid} = useSelector(
    (state: RootStateAgents) => ({totalPaid: state.lawAgents.totalPaid}),
    shallowEqual
  );
  const remainingToPay = totalPaid ? 1000000 - totalPaid : 0;
  const {formatMessage} = useIntl();
  const headerMessage = formatMessage({id: "law-page-title", defaultMessage: "Lawsuit"});
  const remainingToPayMessage = (Boolean(remainingToPay) || remainingToPay === 0)
    ? formatMessage({
    id: "law-page-remainingToPay",
    defaultMessage: "Remaining to pay - {remainingToPay}"
  }, {
    remainingToPay: remainingToPay.toLocaleString('he', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })
  }) : '';
  const resultHeader = [headerMessage, remainingToPayMessage].join(' / ');
  const header = useHeader();
  header.setTitle(resultHeader);
  const subheader = useSubheader();
  subheader.setCustomClassName("subheader-custom-height");
  subheader.setDisplaySubheader(false);

  return <Law/>;
}
